export const STRINGS = {
    HEADERS: {
        PRIMARIES_TITLE: 'NPP PRIMARIES 2023',
        RESULTS: 'RESULTS',
        WIN_MARGIN: 'Win margin:',
        VOTES: 'votes'
    },
    BUTTONS: {
        RESET: 'Reset',
        SHOW_LEGEND: 'Show Legend',
        HIDE_LEGEND: 'Hide Legend'
    },
    LABELS: {
        REGION_SELECTED: 'Selected Region:',
        HEADQUARTERS: 'NPP HEADQUARTERS'
    }
}
